import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppLayout } from '$domains/essentials/pages/AppLayout';
import { CommercePage } from '$domains/essentials/pages/CommercePage';
import { RedirectUser } from '$domains/essentials/redirectsToDrupal/RedirectUser';
import { AppProvider } from './contexts';
import { AppInitializer } from '$core/helpers/AppInitializer';
import { queryClient } from '$core/helpers/queryClient';

const App = ({ language }: { language: string }) => (
  <div className="absolute inset-0 bg-milani-light100 dark:bg-milani-dark100">
    <QueryClientProvider client={queryClient}>
    <AppProvider>
      <AppInitializer>
        {/* <AppHeader /> */}
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route
                path="/"
                element={<Navigate to={`/${language}`} replace />}
              />

            </Route>
            <Route
              path="/redirectUser"
              element={<RedirectUser />}
            />
          </Routes>
          {/* <HomeFooter /> */}
          <CommercePage />
        </BrowserRouter>
      </AppInitializer>
    </AppProvider>
    </QueryClientProvider>
  </div>
);
export { App };
